import { Component, Injector, inject } from '@angular/core';
import { JackBaseComponentModule } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QuillHtmlComponent } from 'jk-service';
import { JkBaseOption } from 'jk-service';
import { JkDialogEditComponent } from 'jk-service';
import { jkRestReturn } from 'jk-service';
import { JkbtneditComponent } from 'jk-advcom';
import { StkwlService } from '../services/Stkwl.service';
import { Stkwl } from '../entity/Stkwl-angular';


export class StkwlPageOption extends JkBaseOption {
  wd015: string = '0';
  simpleVisible: boolean = true;
  constructor(programId: string) {
    super(programId);
  }
}

@Component({
  selector: 'app-stkwl-edit',
  templateUrl: './stkwl-edit.component.html',
  styleUrls: ['./stkwl-edit.component.scss'],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, JkbtneditComponent,
    QuillHtmlComponent,
  ],
})
export class StkwlEditComponent extends JkDialogEditComponent<StkwlService, Stkwl> {
  override dialogRef: MatDialogRef<StkwlEditComponent>;
  override data: jkRestReturn;

  override srv!: StkwlService;
  constructor() {
    const injector = inject(Injector);
    const dialogRef = inject<MatDialogRef<StkwlEditComponent>>(MatDialogRef);
    const data = inject<jkRestReturn>(MAT_DIALOG_DATA);

    super(injector, dialogRef, data);

    this.dialogRef = dialogRef;
    this.data = data;
  }
}
